import { render, staticRenderFns } from "./index.vue?vue&type=template&id=5b204ecd&"
import script from "./index.vue?vue&type=script&lang=js&"
export * from "./index.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/circleci/project/frontend/admin/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5b204ecd')) {
      api.createRecord('5b204ecd', component.options)
    } else {
      api.reload('5b204ecd', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=5b204ecd&", function () {
      api.rerender('5b204ecd', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/Dashboard/index.vue"
export default component.exports